'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_Either() {
}
export { $c_s_util_Either as $c_s_util_Either };
$p = $c_s_util_Either.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
}
export { $h_s_util_Either as $h_s_util_Either };
$h_s_util_Either.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cH)));
}
export { $isArrayOf_s_util_Either as $isArrayOf_s_util_Either };
